<script setup>
  import { Select } from "@/components/episto-ui/select";
  import { useSurveyLocalesStore } from "@stores/survey/surveyLocales";
  import { storeToRefs } from "pinia";

  const surveyLocalesStore = useSurveyLocalesStore();
  const { localeModel, localeOptions } = storeToRefs(surveyLocalesStore);
  const { updateLocale } = surveyLocalesStore;
</script>

<template>
  <Select
    v-if="localeOptions.length > 1"
    :model-value="localeModel"
    :options="localeOptions"
    class="w-auto min-w-[120px]"
    placeholder="Select a language"
    @update:model-value="updateLocale" />
</template>
